import { h, defineComponent, VNodeChildren } from 'vue';
import { starsIcon } from '@/ui/components/icon/icons';

export interface StarredAdItemProps {
  isStarred: boolean;
  tag?: keyof HTMLElementTagNameMap;
}

// old style with one star
export const StarredAdItem = defineComponent<StarredAdItemProps>({
  name: 'StarredAdItem',
  props: ['isStarred', 'tag'],
  setup(props, context) {
    return function render() {
      return h(props.tag ?? 'span', {
        class: 'starred-ad',
      }, [
        props.isStarred ? starsIcon() : null,
        h('span', context.slots.default?.()),
      ]);
    };
  },
});

export function starredAdItem(content: VNodeChildren, isStarred = false, tag = 'span') {
  return h(
    StarredAdItem,
    {
      props: { tag, isStarred },
    },
    content,
  );
}

export const starredAdItemCurried = (isStarred: boolean, tag = 'span') => (content: VNodeChildren) =>
  starredAdItem(content, isStarred, tag);
